import BigNumber from 'bignumber.js'
import { ZERO } from 'constants/number'

interface Props {
  forceDisable?: boolean
  amount: string
  max: BigNumber
  needApprove: boolean
  state: {
    zeroAmount?: string
    zeroMax: string
    overflowAmount: string
    actual: string
  }
}

export const buttonStateHelper = ({
  forceDisable,
  amount: _amount,
  max,
  state: _state,
  needApprove,
}: Props) => {
  const amount = _amount === '' ? ZERO : new BigNumber(_amount)
  let disabled = false
  let state = ''
  if (forceDisable) {
    disabled = true
    state = 'Your position could be liquidated'
  } else if (amount.lt(ZERO)) {
    disabled = true
    state = 'Invalid amount'
  } else if (max.eq(ZERO)) {
    disabled = true
    state = _state.zeroMax
  } else if (amount.eq(ZERO)) {
    disabled = true
    state = _state.zeroAmount || 'Enter amount'
  } else if (amount.gt(max)) {
    disabled = true
    state = _state.overflowAmount
  } else {
    disabled = false
    state = _state.actual
    if (needApprove) state = 'Approve and ' + _state.actual
  }

  return { disabled: disabled, state }
}
